/* eslint-disable */
/**
 * LoenforpligtelserKortListe — vertikal kort-liste til mobil.
 *
 * Viser hver ansat som et kortformat kort:
 *   [Navn] [Aktiv-badge]
 *   [Rolle]
 *   [Beløb/md.]
 *
 * Ingen horisontal scroll — al tekst wrappes vertikalt.
 * Genbrug tokens for konsistens med DESIGN.md.
 *
 * Props:
 *   forpligtelser  Array<{id, navn, rolle, beloeb_md, aktiv}>
 */

import React from 'react';
import { BG, KANT, TEKST, STATUS, RADIUS, FONT } from './tokens';
import StatusBadge from './StatusBadge';

function kroner(tal) {
  if (tal == null) return '—';
  return new Intl.NumberFormat('da-DK', {
    style: 'currency', currency: 'DKK', maximumFractionDigits: 0,
  }).format(typeof tal === 'string' ? parseInt(tal) : tal);
}

export default function LoenforpligtelserKortListe({ forpligtelser = [] }) {
  if (!forpligtelser.length) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {forpligtelser.map((f, i) => (
        <div
          key={f.id ?? i}
          style={{
            background:   BG.kort,
            border:       `1px solid ${KANT.standard}`,
            borderLeft:   `3px solid ${f.aktiv ? STATUS.live : STATUS.ikkeForbundet}`,
            borderRadius: RADIUS.kort,
            padding:      '12px 14px',
            fontFamily:   FONT.family,
          }}
        >
          {/* Række 1: Navn + badge */}
          <div style={{
            display:        'flex',
            alignItems:     'center',
            justifyContent: 'space-between',
            marginBottom:   4,
            gap:            8,
          }}>
            <span style={{
              fontSize:   14,
              fontWeight: 700,
              color:      TEKST.primær,
              // Lange navne wrappes — ingen truncate
              overflowWrap: 'break-word',
              minWidth: 0,
            }}>
              {f.navn}
            </span>
            <StatusBadge
              status={f.aktiv ? 'LIVE' : 'IKKE FORBUNDET'}
              tekst={f.aktiv ? 'Aktiv' : 'Inaktiv'}
              lille
            />
          </div>

          {/* Række 2: Rolle */}
          {f.rolle && (
            <div style={{
              fontSize:     12,
              color:        TEKST.sekundær,
              marginBottom: 8,
            }}>
              {f.rolle}
            </div>
          )}

          {/* Række 3: Beløb */}
          <div style={{
            fontSize:   18,
            fontWeight: 800,
            color:      STATUS.konfigureret,
          }}>
            {kroner(f.beloeb_md)}
            <span style={{
              fontSize:    11,
              fontWeight:  400,
              color:       TEKST.sekundær,
              marginLeft:  4,
            }}>
              /md.
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
